export default "__VITE_ASSET__ed5c4e60__"